"use client";
import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { useId as i } from "react";
//#region src/components/flags/HRFlag.tsx
var a = (e) => {
	let a = i();
	return /* @__PURE__ */ r(t, {
		viewBox: "0 0 24 24",
		fill: "none",
		...e,
		children: [/* @__PURE__ */ r("g", {
			clipPath: `url(#${a}-clip0_103_103)`,
			children: [
				/* @__PURE__ */ n("mask", {
					id: `${a}-path-1-inside-1_103_103`,
					fill: "white",
					children: /* @__PURE__ */ n("path", { d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" })
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 0H30V24H-6V0Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 0H30V8H-6V0Z",
					fill: "#D80027"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 16H30V24H-6V16Z",
					fill: "#0052B4"
				}),
				/* @__PURE__ */ n("path", {
					d: "M15.7053 7.94383V4.85611L16.9334 3.84558L18.1755 4.85611V7.94383H15.7053ZM8.29476 7.94383V4.85611L7.08072 3.84558L5.82458 4.85611V7.94383H8.29476ZM10.7649 7.94383V4.85611L12 3.84558L13.2351 4.85611V7.94383H10.7649Z",
					fill: "#338AF3"
				}),
				/* @__PURE__ */ n("path", {
					d: "M15.7053 7.94383H13.2351V4.85611L14.4632 3.84558L15.7053 4.85611V7.94383ZM10.7649 7.94383H8.29474V4.85611L9.52281 3.84558L10.7649 4.85611V7.94383Z",
					fill: "#0052B4"
				}),
				/* @__PURE__ */ n("path", {
					d: "M5.82458 7.94385V15.0947C5.82458 16.8 6.83511 18.3368 8.30879 19.2631C9.80353 20.2035 11.2632 20.2947 12 20.2947C12.7369 20.2947 14.2035 20.1754 15.6913 19.2561C17.1649 18.3438 18.1755 16.793 18.1755 15.0947V7.94385H5.82458Z",
					fill: "white",
					stroke: "#D80027",
					strokeWidth: .0701754
				}),
				/* @__PURE__ */ n("path", {
					d: "M5.82458 7.94385H8.29476V10.414H5.82458V7.94385ZM10.7649 7.94385H13.2351V10.414H10.7649V7.94385ZM15.7053 7.94385H18.1755V10.414H15.7053V7.94385ZM8.29476 10.414H10.7649V12.8842H8.29476V10.414ZM13.2351 10.414H15.7053V12.8842H13.2351V10.414ZM5.82458 12.8842H8.29476V15.3544H5.82458V12.8842ZM8.29476 15.3544H10.7649V17.8245H8.29476V15.3544ZM10.7649 12.8842H13.2351V15.3544H10.7649V12.8842ZM15.7053 12.8842H18.1755V15.3544H15.7053V12.8842ZM13.2351 15.3544H15.7053V17.8245H13.2351V15.3544ZM15.7053 19.2491C16.3088 18.8702 16.8421 18.386 17.2491 17.8245H15.7053V19.2491ZM6.7509 17.8245C7.15792 18.386 7.68423 18.8702 8.29476 19.2561V17.8245H6.7509ZM10.7649 17.8245V20.1895C11.2702 20.2737 11.6983 20.2947 12 20.2947C12.3018 20.2947 12.7298 20.2737 13.2351 20.1824V17.8245H10.7649Z",
					fill: "#D80027"
				})
			]
		}), /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", {
			id: `${a}-clip0_103_103`,
			children: /* @__PURE__ */ n("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "white"
			})
		}) })]
	});
}, o = {
	12: {
		Artwork: a,
		width: 12,
		height: 12
	},
	16: {
		Artwork: a,
		width: 16,
		height: 16
	},
	20: {
		Artwork: a,
		width: 20,
		height: 20
	},
	24: {
		Artwork: a,
		width: 24,
		height: 24
	}
}, s = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: o[t],
	frame: "circle",
	...r
});
//#endregion
export { s as HRFlag };
